<div class="diagnostic-window-dialog">
    <app-loader [isLoading]="isLoading"></app-loader>
    <div
        class="popupHeader title"
        mat-dialog-title
        cdkDrag
        cdkDragHandle
        cdkDragRootElement=".cdk-overlay-pane"
        cdkDragBoundary=".cdk-overlay-container"
    >
        <span>{{ 'LOCATION_DASHBOARD.DIAGNOSTIC_WINDOW.TITLE' | translate }}</span>
    </div>
    <div mat-dialog-content class="content">
        <div class="location-summary">
            <span class="location-label">{{ 'LOCATION_DASHBOARD.DIAGNOSTIC_WINDOW.LOCATION' | translate }}:</span>
            <span class="location-value">{{ locationName }}</span>
        </div>

        <div class="details">
            <div class="detail-label">
                <span>{{ 'LOCATION_DASHBOARD.DIAGNOSTIC_WINDOW.NEXT_SCHEDULED_CHECK_IN' | translate }}:</span>
                <button
                    *ngIf="!nextExpectedDiagnosticSession"
                    mat-icon-button
                    type="button"
                    class="info-button"
                    [matTooltip]="'LOCATION_DASHBOARD.DIAGNOSTIC_WINDOW.NEXT_SESSION_INFO_TOOLTIP' | translate"
                    [attr.aria-label]="'LOCATION_DASHBOARD.DIAGNOSTIC_WINDOW.NEXT_SESSION_INFO_TOOLTIP' | translate"
                >
                    <mat-icon>info_outline</mat-icon>
                </button>
            </div>
            <div class="detail-value">
                {{
                    nextExpectedDiagnosticSession
                        ? (nextExpectedDiagnosticSession | date: customerDateFormat)
                        : ('LOCATION_DASHBOARD.DIAGNOSTIC_WINDOW.NOT_AVAILABLE' | translate)
                }}
            </div>
            <div class="detail-label frequency-detail-label">
                <span>{{ 'LOCATION_DASHBOARD.DIAGNOSTIC_WINDOW.CHANGE_FREQUENCY' | translate }}</span>
                <button
                    mat-icon-button
                    type="button"
                    class="info-button"
                    [matTooltip]="'LOCATION_DASHBOARD.DIAGNOSTIC_WINDOW.CHANGE_FREQUENCY_INFO_TOOLTIP' | translate"
                    [attr.aria-label]="'LOCATION_DASHBOARD.DIAGNOSTIC_WINDOW.CHANGE_FREQUENCY_INFO_TOOLTIP' | translate"
                >
                    <mat-icon>info_outline</mat-icon>
                </button>
            </div>
            <div class="detail-value">
                {{ 'LOCATION_DASHBOARD.DIAGNOSTIC_WINDOW.ONE_HOUR' | translate }}
            </div>
        </div>

        <div class="settings">
            <div class="control-label duration-label">
                <span>{{ 'LOCATION_DASHBOARD.DIAGNOSTIC_WINDOW.KEEP_OPEN_FOR' | translate }}</span>
                <button
                    mat-icon-button
                    type="button"
                    class="info-button"
                    [matTooltip]="'LOCATION_DASHBOARD.DIAGNOSTIC_WINDOW.KEEP_OPEN_FOR_INFO_TOOLTIP' | translate"
                    [attr.aria-label]="'LOCATION_DASHBOARD.DIAGNOSTIC_WINDOW.KEEP_OPEN_FOR_INFO_TOOLTIP' | translate"
                >
                    <mat-icon>info_outline</mat-icon>
                </button>
            </div>
            <div class="control-label end-label">
                <span>{{ 'LOCATION_DASHBOARD.DIAGNOSTIC_WINDOW.KEEP_UNTIL' | translate }}</span>
                <button
                    mat-icon-button
                    type="button"
                    class="info-button"
                    [matTooltip]="'LOCATION_DASHBOARD.DIAGNOSTIC_WINDOW.KEEP_UNTIL_INFO_TOOLTIP' | translate"
                    [attr.aria-label]="'LOCATION_DASHBOARD.DIAGNOSTIC_WINDOW.KEEP_UNTIL_INFO_TOOLTIP' | translate"
                >
                    <mat-icon>info_outline</mat-icon>
                </button>
            </div>
            <mat-form-field class="full-width duration-control">
                <mat-select
                    [(ngModel)]="selectedDuration"
                    placeholder="{{ 'LOCATION_DASHBOARD.DIAGNOSTIC_WINDOW.SELECT_DURATION' | translate }}"
                    name="duration"
                >
                    <mat-option
                        *ngFor="let option of durationOptions; trackBy: trackByValue"
                        [value]="option.value"
                    >
                        {{ option.labelKey | translate }}
                    </mat-option>
                </mat-select>
            </mat-form-field>
            <div class="datetime-control">
                <mat-form-field class="full-width">
                    <input
                        matInput
                        readonly
                        [min]="minDate"
                        [max]="maxDate"
                        [value]="windowEnd | date: customerDateFormat"
                        placeholder="{{ 'LOCATION_DASHBOARD.DIAGNOSTIC_WINDOW.SET_DATE_TIME' | translate }}"
                        appDatetimepickerPosition
                        [matDatetimepickerComp]="windowEndPicker"
                    />
                    <input
                        hidden
                        [min]="minDate"
                        [max]="maxDate"
                        [matDatetimepicker]="windowEndPicker"
                        name="windowEnd"
                        [ngModel]="windowEnd"
                        (dateChange)="windowEndChanged($event)"
                    />
                </mat-form-field>
                <mat-datetimepicker-toggle class="datetime-toggle" [for]="windowEndPicker"></mat-datetimepicker-toggle>
                <mat-datetimepicker
                    #windowEndPicker
                    timeInterval="1"
                    [type]="'datetime'"
                >
                </mat-datetimepicker>
            </div>
        </div>
    </div>
    <div mat-dialog-actions class="actions custom-flat-button">
        <button mat-button (click)="cancel()">{{ 'COMMON.CANCEL' | translate }}</button>
        <button mat-button [disabled]="!canSave || isSaving" (click)="save()">
            {{ 'COMMON.SAVE_CLOSE_BUTTON' | translate }}
        </button>
    </div>
</div>
